import { render } from "./xAppsPrometheusMobilePage.vue?vue&type=template&id=52b618fb&scoped=true"
import script from "./xAppsPrometheusMobilePage.vue?vue&type=script&lang=js"
export * from "./xAppsPrometheusMobilePage.vue?vue&type=script&lang=js"

import "./xAppsPrometheusMobilePage.vue?vue&type=style&index=0&id=52b618fb&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52b618fb"]])

export default __exports__